import { Alert, Button, Modal } from 'react-bootstrap';

interface IProps {
    messages: string[],
    show: boolean
    onCancel: () => void
}

const DateValidationErrorModal = (props: IProps) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Dates Out of Range </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger' style={{ textAlign: 'center', marginBottom: 0 }}>
                    <div>
                        <ul>
                            {props.messages.map(x=> {
                                return <li style={{marginTop: '2px'}}>{x}</li>
                            })}
                        </ul>
                    </div>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onCancel}>Ok</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DateValidationErrorModal;